import { render, staticRenderFns } from "./fandoms-list.vue?vue&type=template&id=5397e6ff"
import script from "./fandoms-list.vue?vue&type=script&lang=js"
export * from "./fandoms-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports